import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/out_25.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image120.webp';
import slideImg2 from '../images/image36.webp';
import slideImg3 from '../images/image97_.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const nokomisConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Nokomis Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Nokomis, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_nokomis',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Nokomis',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Nokomis Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we proudly serve homeowners and businesses 
     throughout <strong>Nokomis</strong> with expert tree care built for Florida's demanding 
     climate. From overgrown oaks crowding your roofline to storm weakened palms leaning 
     toward your fence or driveway, our team steps in with the precision and professionalism 
     the job requires.`,

    `We specialize in <strong>dangerous tree removal and trimming</strong> including 
     rotted trunks, split limbs after storms, and heavy canopy overgrowth that creates 
     liability for your property. We assess every situation carefully and execute safely, 
     protecting your home and landscaping throughout the process.`,

    `<strong>Sam's Tree Service</strong> offers reliable, affordable tree care across 
     <strong>Nokomis</strong> and the broader <strong>Sarasota County</strong> area 
     giving you peace of mind through every season and every storm.`,
  ],

  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Nokomis, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Nokomis = () => <LocationPage config={nokomisConfig} />;
export default Services_Nokomis;
